const GridViewIcon = ({
  width,
  height,
  className,
  setChangeView,
  changeView,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 27 18'
      fill='none'
      className={className}
      onClick={() => setChangeView(!changeView)}
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='1.125'
        y='1.20508'
        width='5.75'
        height='5.75'
        rx='1.375'
        stroke='#303030'
        strokeWidth='1.25'
        strokeLinejoin='round'
      />
      <rect
        x='10.625'
        y='1.20508'
        width='5.75'
        height='5.75'
        rx='1.375'
        stroke='#303030'
        strokeWidth='1.25'
        strokeLinejoin='round'
      />
      <rect
        x='20.125'
        y='1.20508'
        width='5.75'
        height='5.75'
        rx='1.375'
        stroke='#303030'
        strokeWidth='1.25'
        strokeLinejoin='round'
      />
      <rect
        x='1.125'
        y='11.0452'
        width='5.75'
        height='5.75'
        rx='1.375'
        stroke='#303030'
        strokeWidth='1.25'
        strokeLinejoin='round'
      />
      <rect
        x='10.625'
        y='11.0452'
        width='5.75'
        height='5.75'
        rx='1.375'
        stroke='#303030'
        strokeWidth='1.25'
        strokeLinejoin='round'
      />
      <rect
        x='20.125'
        y='11.0452'
        width='5.75'
        height='5.75'
        rx='1.375'
        stroke='#303030'
        strokeWidth='1.25'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default GridViewIcon;
